"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSuppliers = void 0;
const routes_1 = require("../../routes");
const getSuppliers = (client) => async () => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_SUPPLIERS.path);
    return response.data;
};
exports.getSuppliers = getSuppliers;
